@if (!loadComplete()) {
  <is-wait-message [loadComplete]="loadComplete()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0">
  </is-wait-message>
}
<div class="bolt-container bolt-space-bottom-2xl">

  <bolt-progress-bar appFocusOnInit arialabel="add refund method progress value is 100%" class="progress-bar-container to-container" value="100"></bolt-progress-bar>
  <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Add refund method: confirmation</h1>
  <div class="bolt-row">
    <div class="bolt-col-12">
      @if (errorNotification | async; as errorMessage) {
        <bolt-notification class="bolt-space-bottom-xl to-container" type="error" id="error-notification">
          <div [innerHTML]="errorMessage"></div>
        </bolt-notification>
      } @else {
        <bolt-notification id="confirmation-body" class="bolt-space-bottom-2xl to-container" type="success">
          {{successNotification}}
        </bolt-notification>
        <app-payment-sub-header>Confirmation details</app-payment-sub-header>
        <p class="space-bottom-3"><span class="font-weight-bold">Saved refund
          method:</span><span class="confirmation-message">{{confirmationMessage}}</span></p>
          <p class="space-bottom-3"><span class="font-weight-bold">Saved refund
            method effective date:</span><span class="effective-date">{{effectiveDate}}</span></p>
          }
        </div>
      </div>
    </div>
    <bolt-button-bar>
      <is-button id="print-button" slot="cancel" (click)="showPrintDialog()">Print</is-button>
      <is-button id="submit-button" (click)="onContinue()" slot="forward">Payment preferences</is-button>
    </bolt-button-bar>